import { connect } from 'react-redux';
import { login, loggedIn } from '../../reduxStore/config/user';
import LoginWrapper from './LoginWrapper';

const mapStateToProps = (state, ownProps) => ({
    location: ownProps.location,
    loggedIn: state.user.loggedIn,
    loggingIn: state.user.loggingIn,
    loginFailed: state.user.loginFailed,
    refreshing: state.user.refreshing,
    translation: ownProps.translation,
});

const mapDispatchToProps = dispatch => ({
    handleLogin: (token) => dispatch(login(token)),
    handleLoggedIn: (token) => dispatch(loggedIn(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginWrapper);
